import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrilliance: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBrilliance"><Path d="M12 2.75C9.37665 2.75 7.25 4.82068 7.25 7.375C7.25 13.747 16.75 10.253 16.75 16.625C16.75 19.1793 14.6234 21.25 12 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBrilliance;
